import { useEffect, useState } from 'react';
import { useOfflineDetection } from '../../../hooks/useOfflineDetection';

import { X } from '@phosphor-icons/react';

const OfflineIndicator = () => {
  const isOffline = useOfflineDetection();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!isOffline) {
      setIsDismissed(false);
    }
  }, [isOffline]);

  if (!isOffline || isDismissed) {
    return null;
  }

  return (
    <div className="offline-indicator" role="status" aria-live="assertive">
      <span>
        You appear to be offline. Please check your internet connection.
      </span>
      <button
        type="button"
        aria-label="Dismiss offline status message"
        onClick={() => setIsDismissed(true)}
      >
        <X />
      </button>
    </div>
  );
};

export default OfflineIndicator;
